import Swiper, { Autoplay, Navigation, Pagination } from "swiper";

class HBOSlider {

	constructor() {
		const _this = this;
		const compilationsSliderBlock = document.querySelector('.compilations-slider');

		const compilationsSlider = new Swiper(".compilations-slider", {
			modules: [Navigation, Pagination, Autoplay],
			loop: false,
			autoplay: {
				delay: 6000
			},
			updateOnWindowResize: true,
			slidesPerView: 1,
			spaceBetween: 0,
			navigation: {
				nextEl: document.querySelector(".compilations-slider .compilations--slider-btn__next") as HTMLElement,
				prevEl: document.querySelector(".compilations-slider .compilations--slider-btn__prev") as HTMLElement
			},
			pagination: {
				el: document.querySelector(".compilations-slider .swiper-pagination") as HTMLElement,
				clickable: true,
				dynamicBullets: true,
				dynamicMainBullets: 1,
				bulletActiveClass: "_active",
				renderBullet: (index, className) => `<div class="compilations--nav__item ${ className }"></div>`
			},
			breakpoints: {
				576: {
					allowTouchMove: false,
				}
			}
		});
		compilationsSlider.autoplay.stop();

		new Swiper(".hbo-serials--list", {
			slideClass: "hbo-slide",
			loop: false,
			/*grabCursor: true,*/
			slidesPerView: "auto",
			spaceBetween: 0,
			updateOnWindowResize: true,
		});

		if (document.querySelector('body').classList.contains('home-page--new')) {
			window.addEventListener("scroll", autoplayStart);
			autoplayStart();
		}

		function autoplayStart() {
			if (_this.isVisible(compilationsSliderBlock)) {
				compilationsSlider.autoplay.start();
				window.removeEventListener('scroll', autoplayStart);
			}
		}
	}

	isVisible(elem) {
		const rect = elem.getBoundingClientRect();

		return rect.top < window.innerHeight && rect.top > 0 && rect.bottom > 0;
	};
}

export default HBOSlider;
